.information-card{border-radius:15px;border:1px solid;width:248px!important}
/*# sourceMappingURL=information-card.component-XX4GYUW7.css.map */
